import type { GetTotalReportsCreatedResponseDTO } from '@/core/dto/custom-reports/get-total-reports-created';
import { Mapper } from '@/core/mapper/base-mapper';
import { I18n } from '@aws-amplify/core';
import { REPORT_NAME_KEYS, REPORT_TYPES, REPORT_NAMES_MAP } from '@/utils/constants';

export class GetTotalReportsCreatedMapper implements Mapper<GetTotalReportsCreatedResponseDTO> {
	constructor(private readonly data: GetTotalReportsCreatedResponseDTO) {}

	private getReportType(name: string): string {
		if (name === REPORT_NAME_KEYS.BERA) return REPORT_TYPES.BERA;
		if (name === REPORT_NAME_KEYS.SERA) return REPORT_TYPES.SERA;
		return REPORT_TYPES.CUSTOM;
	}

	private getFormattedName(name: string): string {
		return I18n.get(REPORT_NAMES_MAP[name] || name);
	}

	toDomain(): GetTotalReportsCreatedResponseDTO {
		return this.data.map((item) => ({
			...item,
			report_type: this.getReportType(item.name),
			formatted_name: this.getFormattedName(item.name)
		}));
	}
}
